export default __webpack_public_path__ + "static/media/NoInvestment.ea6e04bb.svg";